const modulesTopics = [
  {
    id: 1,
    title: 'Module 1',
    description: 'Climate change',
    icon: '/img/icons/coursemoduleicons/001-climate-change.svg',
  },
  {
    id: 2,
    title: 'Module 2',
    description: 'Impact of climate change',
    icon: '/img/icons/coursemoduleicons/002-disaster.svg',
  },
  {
    id: 3,
    title: 'Module 3',
    description: 'Climate change adaptation',
    icon: '/img/icons/coursemoduleicons/003-environmental-protection.svg',
  },
  {
    id: 4,
    title: 'Module 4',
    description: 'Funding & advocacy',
    icon: '/img/icons/coursemoduleicons/004-cost.svg',
  },
]

const moduleOne = {
  id: 1,
  title: 'Climate change',
  icon: '/img/icons/coursemoduleicons/001-climate-change.svg',
  sessions: [
    {
      id: 1,
      title: 'Understanding Climate Change',
      icon: '/img/icons/coursemoduleicons/008-idea.svg',
      parts: [
        {
          id: 1,
          title: 'Understanding Climate Change',
          description: 'To understand climate change, we need to know the difference between weather, climate (change), and climate variability.',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Weather',
              icon: '/img/icons/coursemoduleicons/010-today.svg',
              description: [
                "Weather refers to the short-term atmospheric conditions in a specific place at a specific time. For example, when you check the forecast to see if you need an umbrella today, you're looking at the weather. It's things like rain, sun, hot, or cold. But as well things like temperature, humidity, precipitation, cloudiness, visibility, and wind.",
                'For example: if it’s raining on Monday morning but the sun is out by lunchtime - that’s a change in the weather.',
              ],
            },
            {
              id: 2,
              title: 'Climate',
              icon: '/img/icons/coursemoduleicons/011-weather-forecast.svg',
              description: [
                'Climate is the average of weather conditions over a longer period, typically 30 years or more, in a particular location. For instance, a region with a tropical climate tells you that it generally experiences warm temperatures and significant rainfall throughout the year.',
                'For example: if an older person tells you that 40 years ago there was a lot more rain in a particular month where they live than today, they could be talking about climate change.',
              ],
            },
            {
              id: 3,
              title: 'Climate variability',
              icon: '/img/icons/coursemoduleicons/012-meteorology.svg',
              description: [
                "Climate variability is the natural fluctuations in climate patterns over relatively short periods, such as years or decades. These variations can be caused by natural processes within the climate system, such as oceanic circulation patterns like El Niño and La Niña. These variations are a normal part of the Earth's climate system and can have significant impacts on weather patterns, agriculture, water resources, and ecosystems.",
                'For example: one year might be warmer or wetter than the average, while the next year could be cooler or drier.',
              ],
            },
            {
              id: 4,
              title: 'Climate change',
              icon: '/img/icons/coursemoduleicons/013-temperature.svg',
              description: [
                'Climate change refers to the long-term changes in the Earth’s climate. It causes weather patterns to be less predictable, affecting the balance of Earth’s precious ecosystems. These changes persist for long periods, typically decades or more.',
                'For example: Malawi is experiencing more frequent and intense droughts, floods, and cyclones.',
              ],
            },
          ],
        },
        {
          id: 2,
          title: 'Causes of climate change',
          icon: '',
          subtitle: 'Natural causes of climate change',
          description: 'Changes in climate can be caused by natural causes but, today, climate change is commonly understood to indicate human-induced climate change, and almost all observed changes are driven by human activities.',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Solar radiation',
              icon: '/img/icons/coursemoduleicons/016-radiation.svg',
              description: [
                'Solar variations, such as changes in solar radiation and sunspot activity, can influence Earths climate over long periods. They affect climate patterns, such as temperature changes and atmospheric circulation.',
              ],
            },
            {
              id: 2,
              title: 'Volcanic eruptions',
              icon: '/img/icons/coursemoduleicons/017-volcano.svg',
              description: [
                'Volcanic eruptions, release large amounts of volcanic gases and aerosols into the atmosphere. Volcanic aerosols can scatter and reflect sunlight, leading to a temporary cooling effect on the Earth surface.',
              ],
            },
            {
              id: 3,
              title: 'Earth orbital changes',
              icon: '/img/icons/coursemoduleicons/018-climate-change-2.svg',
              description: [
                'Earth orbital changes affect the distribution and intensity of solar radiation received by different parts of the Earth, which can lead to changes in climate patterns.',
              ],
            },
          ],
        },
        {
          id: 3,
          title: 'Human causes of climate change',
          icon: '',
          description: 'Most observed changes since the mid-20th century are overwhelmingly human-caused. The reasons for this are human activities such as:',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Deforestation',
              icon: '/img/icons/coursemoduleicons/022-deforestation.svg',
              description: [
                'Trees act as carbon sinks, absorbing carbon dioxide from the atmosphere through photosynthesis. When forests are cleared or burned, the stored carbon is released into the atmosphere as carbon dioxide (CO₂), contributing to the greenhouse effect.',
              ],
            },
            {
              id: 2,
              title: 'Agriculture activities',
              icon: '/img/icons/coursemoduleicons/023-manure.svg',
              description: [
                'The use of synthetic fertilisers in agriculture releases nitrous oxide (N₂O), another potent greenhouse gas.',
              ],
            },
            {
              id: 3,
              title: 'Industrial processes',
              icon: '/img/icons/coursemoduleicons/024-factory.svg',
              description: [
                'Industries release significant amounts of CO₂, methane (CH₄), and other greenhouse gases during manufacturing, energy production, and chemical processes. These emissions contribute to the enhanced greenhouse effect and climate change.',
              ],
            },
            {
              id: 4,
              title: 'Burning fossil fuels',
              icon: '/img/icons/coursemoduleicons/additional.svg',
              description: [
                'Burning fossil fuels (like coal, oil and gas) for heating, cooling and transport, release CO₂ in the atmosphere.',
              ],
            },
          ],
        },
        {
          id: 4,
          title: 'The Greenhouse effect',
          description: 'Greenhouse gases in the atmosphere act like a thermal blanket, keeping the planet’s temperature relatively stable between day and night and across seasons. The sun emits radiation (thermal energy), and some of this energy enters the Earth’s atmosphere. One part of this energy is absorbed by the Earth’s atmosphere; the rest is reflected back into space. The gases that trap heat, such as water vapour, CO₂ (carbon dioxide),  N₂O (nitrous oxide),  and CH₄ (methane), are called greenhouse gases (GHGs). ',
          template: 'infographic',
          image: '/img/icons/coursemoduleicons/large.png',
          imageCopyright: 'Copyright © 2026 BBC',
          caption: 'An amplified greenhouse effect is the driver of climate change due to human activities. The greenhouse effect is essential for sustaining life on Earth, but many human activities are amplifying it to harmful levels. Activities like burning fossil fuels release CO₂, increase atmospheric greenhouse gas concentrations, and, as such, amplify the natural greenhouse effect, making the Earth much hotter in the future than today.',
        },
        {
          id: 5,
          title: 'Effects of greenhouse gases',
          icon: '',
          subtitle: '',
          description: '',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Impact on climate',
              icon: '/img/icons/coursemoduleicons/019-global-warming.svg',
              description: [
                'Greenhouse gases trap heat, leading to rising temperatures, disrupting global climate patterns and causing more intense and frequent extreme weather events, causing melting of the ice caps, loss of biodiversity and sea level rise.',
              ],
            },
            // {
            //   id: 2,
            //   title: 'Climate change',
            //   icon: '/img/icons/coursemoduleicons/013-temperature.svg',
            //   description: [
            //     'Disrupting global climate patterns, causing sea-level rise, and altering precipitation patterns.',
            //   ],
            // },
            {
              id: 2,
              title: 'Air pollution',
              icon: '/img/icons/coursemoduleicons/020-pollution.svg',
              description: [
                'Greenhouse gases contribute to poor air quality, negatively impacting human health, and damaging crops.',
              ],
            },
            {
              id: 3,
              title: 'Ocean acidification',
              icon: '/img/icons/coursemoduleicons/021-ocean-acidification.svg',
              description: [
                'Greenhouse gases increase ocean acidity, harming marine life, especially coral reefs and shellfish.',
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: 'Climate Change risks',
      icon: '/img/icons/coursemoduleicons/009-disaster-management.svg',
      parts: [
        {
          id: 1,
          title: 'Risks and hazards',
          icon: '',
          description: '',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Climate hazards',
              // icon: '/img/icons/coursemoduleicons/025-dry-area.svg',
              // subtitle: '',
              description: ['Climate hazards refer to the extreme weather events (such as floods or wildfires) or long-term shifts (such as sea level rise) that can cause harm. '],
            },
            {
              id: 2,
              title: 'Climate risk',
              // icon: '/img/icons/coursemoduleicons/025-dry-area.svg',
              // subtitle: '',
              description: ['Climate risks are the potential negative consequences for humans or ecological systems that result from the occurrence of a climate hazard in a place where population or assets are exposed, and these are vulnerable or susceptible to damage.'],
            },
          ],
        },
        {
          id: 2,
          title: 'Climate Change risks',
          icon: '',
          description: 'Climate change risks include those associated with: prolonged dry spells or droughts, heavy rains and floods, heat waves, wild fires, and extreme winds.',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Prolonged dry spells',
              icon: '/img/icons/coursemoduleicons/025-hand-holding-droplet-solid-full.svg',
              subtitle: 'There are significant risks associated with climate change impacting ecosystems, agriculture, water supply, and human health. Extended periods without rainfall can lead to:',
              type: 'bullet',
              description: [
                'Reduced soil moisture, impacting crop growth and yield.',
                'Reduced availability of forage and water for livestock, increasing health issues and mortality rates.',
                'Soil erosion, nutrient depletion, and loss of arable land.',
                'Decrease in freshwater availability in lakes, rivers, and reservoirs or even groundwater, impacting drinking water supplies.',
                'Increase the risks of wildfires, which can devastate forests and grasslands.',
              ],
            },
            {
              id: 2,
              title: 'Heavy rains and floods',
              icon: '/img/icons/coursemoduleicons/cloud-rain-regular-full.svg',
              subtitle: 'Climate change significantly influences weather patterns, leading to more intense and frequent extreme weather events, including heavy rains and floods. Increased rainfall is a result of warmer temperatures as the atmosphere holds more moisture, which can lead to:',
              type: 'bullet',
              description: [
                'Soil erosion affecting crop production leads to food insecurities.',
                'Infrastructure vulnerability.',
                'Post-flood environment leading to the spread of waterborne diseases.',
              ],
            },
            {
              id: 3,
              title: 'Heat waves',
              icon: '/img/icons/coursemoduleicons/temperature-sun-light-full.svg',
              description: [
                'Temperature plays a fundamental role in human health, agricultural productivity and biodiversity. Heat is an important environmental hazard as heat stress is the leading cause of weather-related deaths. In general, climate change is increasing the frequency, intensity, and duration of heat waves.',
              ],
            },
            {
              id: 4,
              title: 'Fires',
              icon: '/img/icons/coursemoduleicons/fire-light-full.svg',
              description: [
                'Wildfire describes an uncontrolled burning fire, usually originating in natural areas, which can cause damage to forestry, agriculture, infrastructure and buildings. Wildfires that occur naturally are usually triggered by extreme heat and drought conditions, but also by lightning storms. In general, climate change is leading to warmer, drier conditions that amplify fire risk.',
              ],
            },
            {
              id: 5,
              title: 'Extreme wind',
              icon: '/img/icons/coursemoduleicons/wind-warning-light-full.svg',
              description: [
                'Wind related risks can be categorised as strong winds (storminess) or tropical cyclones. Tropical cyclones are rapidly rotating storms that develop over warm tropical oceans, from which they draw the energy to intensify. In general, climate change is projected to impact several aspects of tropical cyclone activity.',
              ],
            },
          ],
        },
      ],
    },
  ],
}

const moduleTwo = {
  id: 2,
  title: 'Climate change',
  icon: '/img/icons/coursemoduleicons/001-climate-change.svg',
  sessions: [
    {
      id: 1,
      title: 'Agriculture, health and education',
      icon: '/img/icons/coursemoduleicons/027-flask.svg',
      parts: [
        {
          id: 1,
          title: 'Impacts of climate change on agriculture',
          template: 'infographic',
          image: '/img/coursemoduleimages/agriculture.png',
        },
        {
          id: 2,
          title: 'Impacts of climate change on health and well-being',
          template: 'infographic',
          image: '/img/coursemoduleimages/health.png',
        },
        {
          id: 3,
          title: 'Impacts of climate change on education',
          description: 'Climate change increases disasters that disrupt access to education and livelihoods, leading to losses that force children, especially girls, out of schools. It is estimated that at least four million girls in low- and middle-income countries will not be able to complete their schooling due to the impacts of climate change.',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Climate change affects education through several channels:',
              type: 'bullet',
              description: [
                'Disasters disrupt access to education by damaging schools and infrastructure or repurposing school buildings as shelters/evacuation centres, which reduces both the availability and long-term quality of education.',
                'Children’s learning and continuous school attendance are negatively affected by insecurity crises and disease outbreaks caused by slow-onset climate disasters (e.g., increasing temperatures, land and forest degradation, salinisation and biodiversity loss).',
                'Disasters increase school drop-out, as children and girls in particular leave school to support family livelihoods and household chores (e.g., water and fuel collection). Climate-related events directly affect rural households’ income sources by reducing yields, destroying crops and livestock. In contexts of poverty, families often prioritise income over schooling.',
              ],
            },
          ], 
        },
      
      ],
    },
    {
      id: 2,
      title: 'Natural Resource Management',
      icon: '/img/icons/coursemoduleicons/028-renewable-resources.svg',
      parts: [
        {
          id: 1,
          title: 'Natural resources',
          description: 'Natural resources are materials or substances that occur naturally in the environment used by living organisms for their sustenance and economic activities.',
          template: 'explanation',
          subtitle: 'Classes of natural resources',
          subparts: [
            {
              id: 1,
              title: 'Renewable resources',
              icon: '/img/icons/coursemoduleicons/030-energy-conversion.svg',
              description: [
                'These can be replenished naturally over time.',
                'For example: sunlight, wind, water, forests, soil, and wildlife.',
              ],
            },
            {
              id: 2,
              title: 'Non-Renewable resources',
              icon: '/img/icons/coursemoduleicons/031-fossil-fuels.svg',
              description: [
                'These exist in limited quantities and take millions of years to form.',
                'For example:  Fossil fuels (coal, oil, natural gas). Minerals and metals.',
              ],
            },
          ],
        },
        {
          id: 2,
          title: 'Key impacts',
          description: '',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Impacts of climate change on sustainable forestry',
              // subtitle: 'Increased risk of wildfires due to prolonged dry spells and higher temperatures.',
              type: 'bullet',
              description: [
                'Increased risk of wildfires due to prolonged dry spells and higher temperatures.',
                'Reduced tree growth and productivity from changing precipitation patterns.',
                'Loss of biodiversity as species struggle to adapt to rapid climatic shifts.',
                'Forest degradation due to pests and diseases exacerbated by warmer climates.',
              ],
            },
            {
              id: 2,
              title: 'Impacts of climate change on soil and water',
              type: 'bullet',
              description: [
                'Soil erosion from intensified rainfall and flooding.',
                'Reduced soil fertility due to loss of organic matter under extreme weather conditions.',
                'Declining groundwater levels and surface water availability from prolonged dry spells.',
                'Sedimentation in water bodies affects water quality and storage capacity.',
              ],
            },
            {
              id: 3,
              title: 'Impacts of climate change on fisheries',
              type: 'bullet',
              description: [
                'Changes in water temperature affect fish breeding, growth, and distribution.',
                'Use of organic/chemical fertilisers and herbicides, which are washed into the rivers and lakes, affects aquatic life.',
                'Increased vulnerability to invasive species and diseases.',
              ],
            },
          ],

        },
      ],
    },
    {
      id: 3,
      title: 'Women and youth',
      icon: '/img/icons/coursemoduleicons/029-children.svg',
      parts: [
        {
          id: 1,
          title: 'How climate change affects youth',
          description: 'Climate change affects youth to a greater extent, as they are more vulnerable to long-term consequences. As we saw in <a href="/learn/module/2/session/1/part/3">session 1</a>, extreme weather events, such as droughts and floods, disrupt education by limiting access to schools and forcing some young people, especially girls, to help with household or agricultural tasks. Their health and nutrition are also affected, with increased risks of malnutrition and water- or heat-related illnesses. Additionally, youth often have less economic power, which limits their ability to adapt to climate change. They bear the brunt of resource scarcity, including water and food shortages.',
          template: 'explanation',
        },
        {
          id: 2,
          title: 'How climate change intensifies gender inequalities',
          description: 'Climate change increases existing inequalities and creates extra risks for women and girls. This happens because they often have less access to resources, are expected to take on certain roles in society, and have less influence in decision-making. Additionally, girls who face intersecting forms of marginalisation, such as race, disability, or economic status, are among the most affected by climate change due to discriminatory gender and social norms.',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Crop failure',
              icon: '/img/icons/coursemoduleicons/032-crop.svg',
              description: [
                'Affects household food provision; increasing women’s and girls’ workload to provide food for the household.',
              ],
            },
            {
              id: 2,
              title: 'Fuel shortage',
              icon: '/img/icons/coursemoduleicons/033-deforestation-1.svg',
              description: [
                'Affects household fuel provision: more time for fuelwood collection, which is often done by women and girls.',
              ],
            },
            {
              id: 3,
              title: 'Water scarcity',
              icon: '/img/icons/coursemoduleicons/034-hand-pump.svg',
              description: [
                'Low household water availability and declining water levels force people to travel long distances to collect water, a task primarily carried out by women and girls.',
              ],
            },
            {
              id: 4,
              title: 'Natural disasters',
              icon: '/img/icons/coursemoduleicons/035-avatar.svg',
              description: [
                'Women and girls usually have limited access to early warning information that can enable them to prepare for disasters. Additionally, during climate-induced disasters, women and girls who are displaced are often exposed to unfavourable living conditions (limited access to sanitary facilities, threat of violence, etc.).',
              ],
            },
            {
              id: 5,
              title: 'Gender-based violence',
              icon: '/img/icons/coursemoduleicons/violence.svg',
              description: [
                'Climate change drives displacement, loss of livelihoods, and humanitarian emergencies; factors that significantly increase the risks of gender-based violence (GBV). When climate-vulnerable households are grappling with lost incomes and increased stress, it can lead to negative coping mechanisms, increasing intimate partner violence and early and forced marriage. Sexual exploitation and abuse increase in emergency shelters, and in transit when people are displaced, and support services are harder to access.',
              ],
            },
          ],
        },
        {
          id: 3,
          title: 'Women and youth engagement',
          description: 'Engaging women and youth in climate action is essential for developing effective and more inclusive responses to climate change. Women and young people are not only among the most affected by its impacts, but they are also key agents of change.<br /><br />As noted earlier, women and youth often have less economic power, which can limit their ability to adapt to climate-related challenges. They are disproportionately affected by resource scarcity, including water and food shortages, yet their unique perspectives and experiences make them vital contributors to sustainable solutions.',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Gendered roles and knowledge',
              description: [
                'Because of gendered roles and systemic barriers, women and girls, especially young women, often hold specific expertise in areas such as water collection, biodiversity management, agriculture, and ecosystem stewardship. This knowledge, however, is frequently overlooked in formal climate planning. Ensuring their equal participation and leadership in climate decision-making leads to more effective and just solutions.',
              ],
            },
            {
              id: 2,
              title: 'Inclusive climate policies',
              description: [
                'Effective climate policies must consider gender and age inequalities and empower women and youth to participate in and lead climate action. Limited youth participation can lead to policies that don’t fully address the concerns and perspectives of younger generations, who are most impacted by the long-term impacts of climate change. The lack of girls’ participation, in particular, results in interventions and policies that fail to address their specific needs and challenges, risking the reinforcement of existing gender inequalities.',
              ],
            },
          ],

        },
      ],
    },
  ],
}

const moduleThree = {
  id: 3,
  title: 'Climate change adaption',
  icon: '/img/icons/coursemoduleicons/003-environmental-protection.svg',
  sessions: [
    {
      id: 1,
      title: 'Adaptation and mitigation',
      icon: '/img/icons/coursemoduleicons/038-reduce.svg',
      parts: [
        {
          id: 1,
          title: 'Adaptation and mitigation: definition and examples',
          template: 'infographic',
          image: '/img/coursemoduleimages/migration.png',
        },
        {
          id: 2,
          title: 'Adaptation strategies and risk reduction measures',
          template: 'checklist',
          subparts: [
            {
              id: 1,
              title: 'Early warning systems',
              description: ['Early warning systems are put in place to analyse and identify potential weather- and climate-related risks and hazards. All early warning systems aim at enabling early action to save and protect lives, livelihoods and assets of people at risk.'],
            },
            {
              id: 2,
              title: 'Increased risk knowledge and climate education',
              description: ['Improve people’s understanding of climate change, their causes and effects, and strengthen their ability to prepare for, respond to, and reduce climate risks.'],
            },
            {
              id: 3,
              title: 'Inclusive emergency response',
              description: ['is an immediate, systematic response to an unexpected or dangerous occurrence. The goal of an emergency response procedure is to mitigate the impact of the event on people, property, and the environment'],  
            },
            {
              id: 4,
              title: 'Climate resilient health and education system',
              description: ['Improve continuous access to services during and after climate-related events, for instance through mobile clinics, temporary learning centres, contingency planning, heat management, etc.'],
            },
            {
              id: 5,
              title: 'Livelihood diversification',
              description: ['Diversification of income sources helps protect households from climate-related shocks.'],
            },
            {
              id: 6,
              title: 'Anticipatory action and social protection',
              description: ['ensure most at risk households have early access to social protection through cash transfers, insurance covering income loss etc.'],
            },
            {
              id: 7,
              title: 'Disaster-resistant infrastructures',
              description: ['can withstand extreme weather events or disasters like heavy rains and floods, for example a flood-resistant bridge.'],
            },
            {
              id: 8,
              title: 'Nature based solutions',
              description: [
                '<strong>Soil and water conservation</strong> is the management of natural resources (water and soil) to prevent environmental degradation and ensure long-term land productivity.<ul style="margin-block: 0"><li><strong>Soil Conservation:</strong> The practice of protecting soil from erosion (by wind or water) and maintaining its fertility. It involves preventing the loss of the nutrient-rich topsoil layer.</li><li><strong>Water Conservation:</strong> The sustainable management of water resources. This includes reducing waste, protecting water quality, and improving the "harvesting" of rainwater to recharge groundwater.</li></ul>',
                '<strong>Climate-smart agriculture:</strong> Will be further explained in <a href="/learn/module/3/session/2/part/1">module 3.</a>',
                '<strong>Agroforestry:</strong> is a land management system that intentionally integrates trees or shrubs with crops and/or livestock on the same piece of land.',
                '<strong>Watershed management:</strong> is the process of organising and guiding water use within a specific drainage basin to protect water quality, ecosystem health, for instance, by protecting plants that stabilise the soil and filter water.',
                '<strong>Clean and green cooking technologies:</strong> refer to a range of fuels and appliances designed to minimise health risks and environmental impact. An example is using animal dung to reduce the amount of firewood needed for cooking.',
                '<strong>Waste management:</strong> various actions taken to manage waste to minimise environmental impact and comply with regulations.',
              ],
            },
            
          ],
        },
        {
          id: 3,
          title: 'Climate change mitigation measures',
          template: 'checklist',
          subparts: [
            {
              id: 1,
              title: 'Reducing greenhouse gas emissions',
              icon: '/img/icons/coursemoduleicons/039-zero-emission.svg',
              type: 'bullet',
              description: [
                'Transition into green and clean cooking technology.',
              ],
            },
            {
              id: 2,
              title: 'Enhancing carbon sinks',
              icon: '/img/icons/coursemoduleicons/040-atmospheric-pollution.svg',
              type: 'bullet',
              description: [
                'Afforestation and reforestation, where communities should plant trees and restore forests to absorb GHGs like CO₂.',
                'Adopt agricultural practices like cover cropping and agroforestry that enhance soil health and increase carbon storage.',
              ],
            },
            {
              id: 3,
              title: 'Waste management',
              icon: '/img/icons/coursemoduleicons/garbage-bag.svg',
              type: 'bullet',
              description: [
                'Some waste management practices, such as capturing and utilizing energy from waste, reducing waste and increasing recycling, and implementing well-managed composting systems, help reduce greenhouse gas emissions.',
              ],
            },
            {
              id: 4,
              title: 'Climate-smart agriculture',
              icon: '/img/icons/coursemoduleicons/036-sustainability.svg',
              type: 'bullet',
              description: [
                'Some climate smart agriculture practices can also support the reduction of emissions. For example, they can lower methane emissions from livestock and rice production, as well as nitrous oxide emissions from fertilizers.',
              ],
            },
            {
              id: 5,
              title: 'Policy and regulations',
              icon: '/img/icons/coursemoduleicons/043-file.svg',
              type: 'bullet',
              description: [
                'Implement strict emission standards and enforce regulations on emissions on industries– this can mainly be applicable in developed countries.',
                'In Malawi,  advocate for Climate Justice where those polluting countries are requestedto pay developing countries that are taking possible actions to enhance carbon sinks',
                'Ensure the role of the state in mitigating the climate change risks is played.',
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: 'Climate-smart solutions',
      icon: '/img/icons/coursemoduleicons/036-sustainability.svg',
      parts: [
        {
          id: 1,
          title: 'Overview of Climate-Smart Agriculture (CSA) Techniques',
          description: 'CSA according to FAO is defined as: Agriculture that sustainably increases productivity, enhances resilience (adaptation), reduces/removes GHGs (mitigation) where possible, and enhances achievement of national food security and development goals.',
          subtitle: 'Key Climate-Smart Techniques:',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Conservation agriculture',
              icon: '/img/icons/coursemoduleicons/044-sustainable-agriculture.svg',
              description: [
                'This practice focuses on minimal soil disturbance, permanent soil cover, and crop rotation to improve soil health, water retention, and nutrient cycling.',
                'For example: permanent soil cover programs, integrated crop-livestock systems, crop rotation and diversification.',
              ],
            },
            {
              id: 2,
              title: 'Agroforestry',
              icon: '/img/icons/coursemoduleicons/045-agroforestry.svg',
              description: [
                'This technique integrates trees and shrubs into farming systems to provide multiple benefits, such as shade, windbreaks, improved soil fertility, and biodiversity conservation. i.e. Fildebia albida, Grilicidia sepiam, Tephrosia vogelli.',
                'For example: trees act as flood defences, improve water management systems, and support climate-resilient agriculture.',
              ],
            },
            {
              id: 3,
              title: 'Drought-resistant crops',
              icon: '/img/icons/coursemoduleicons/046-failure.svg',
              description: [
                'Planting crops that are tolerant to drought stress can help farmers mitigate the impacts of climate variability and change.',
                'For example: cassava, sweet potatoes.',
              ],
            },
          ],
        },
      ],
    },
    {
      id: 3,
      title: 'Integrating knowledge into practice',
      icon: '/img/icons/coursemoduleicons/037-mastery.svg',
      parts: [
        {
          id: 1,
          title: "Tailoring solutions to Malawi's unique contexts",
          description: 'Climate change impacts vary across different regions of Malawi. Therefore, it is crucial to develop adaptation solutions that are tailored to the specific needs and conditions of each community.',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Local knowledge',
              icon: '/img/icons/coursemoduleicons/047-brainstorming.svg',
              description: [
                'Incorporate traditional knowledge and practices into adaptation strategies.',
              ],
            },
            {
              id: 2,
              title: 'Community engagement',
              icon: '/img/icons/coursemoduleicons/048-community.svg',
              description: [
                'Involve community members, including adolescents and youth, in the planning, implementation and monitoring of adaptation projects.',
              ],
            },
            {
              id: 3,
              title: 'Gender equality',
              icon: '/img/icons/coursemoduleicons/049-gender-equality.svg',
              description: [
                'Ensure that women, girls, and marginalised groups are included in decision-making and benefit from adaptation initiatives.',
              ],
            },
          ],
        },
      ],
    },
  ],
}

const moduleFour = {
  id: 4,
  title: 'Funding & advocacy',
  icon: '/img/icons/coursemoduleicons/004-cost.svg',
  sessions: [
    {
      id: 1,
      title: 'Climate finance',
      icon: '/img/icons/coursemoduleicons/051-investment.svg',
      parts: [
        {
          id: 1,
          title: 'What is climate finance?',
          description: 'Climate finance is money and investments used to tackle climate change. It includes loans, grants, investments, guarantees, and carbon market mechanisms. It encompasses the funding required for both mitigation (reducing or preventing greenhouse gas emissions) and adaptation (adjusting to the adverse effects of climate change). The ultimate goal of climate finance is to support sustainable development and help countries transition to low-carbon, climate-resilient economies.',
          subtitle: 'What projects can we implement with climate finance?',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Mitigation',
              icon: '/img/icons/coursemoduleicons/050-no-emission.svg',
              description: [
                'Financing projects that reduce or avoid greenhouse gas emissions.',
                'For example: renewable energy projects, energy efficiency programs, and sustainable transportation.',
              ],
            },
            {
              id: 2,
              title: 'Adaptation',
              icon: '/img/icons/coursemoduleicons/003-environmental-protection.svg',
              description: [
                'Funding activities that help communities adapt to the adverse effects of climate change.',
                'For example: building flood defences, improving water management systems, and supporting climate-resilient agriculture.',
              ],
            },
          ],
        },
        {
          id: 2,
          title: 'How can youth access climate finance?',
          subtitle: '',
          description: 'There are several funding sources available for climate-related projects. Some of them are accessible to youth organizations.',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Types of climate finance',
              type: 'bullet',
              description: [
                'Global Youth Climate Action Fund (GYCAF)',
                'Youth Climate Justice Fund (YCJF)',
                'UNDP Youth4Climate Initiative',
                'Climate Investment Funds (CIF) Youth Programmes (Youth Adapt Challenge / CIF Youth Fellowship)',
                'Philanthropic and civil society climate finance (e.g., Plan International Equality Accelerator, AfDB Youth Adapt Challenge)',
                'Local Funders – NGOs working in areas like Kasungu, and groups like Carbon C-Quest.',
                'International funds – Green Climate Fund (GCF), Global Environment Facility (GEF), Adaptation Fund.',
                'Banks – World Bank, African Development Bank, Asian Development Bank.',
                'Governments – Countries like the USA, Germany, and Japan support climate projects.',
                'Carbon Markets – Selling carbon credits for eco-friendly projects',
              ],
            },
          ],
        },
        {
          id: 3,
          title: 'How to access climate finance',
          subtitle: '',
          description: 'Generally, the steps to get funding opportunities are as follows:',
          template: 'checklist',
          subparts: [
            {
              id: 1,
              title: 'Create a strong proposal',
              description: [
                'Match the fund’s goals – Your project should focus on climate action (reducing pollution or adapting to climate change).',
                'Show impact – Explain how your project helps the environment and people.',
                'Plan for success – Include costs, expected results, and how it will last long-term.',
              ],
            },
            {
              id: 2,
              title: 'Build Institutional Capacity',
              description: [
                'An office or working space.',
                'Clear rules (Code of Conduct, Organogram).',
                'Good project management skills.',
              ],
            },
            {
              id: 3,
              title: 'Work with others',
              description: [
                'Team up with local governments, businesses, NGOs, and communities.',
                'Partnerships make proposals stronger and show local support.',
              ],
            },
            {
              id: 4,
              title: 'Apply for funding',
              description: [
                'Step 1: Submit a short concept note (a summary of your project).',
                'Step 2: Send a full proposal with details about finances, goals, and operations.',
                'Step 3: Answer any questions, make changes if needed, and wait for approval.',
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      title: 'Policy advocacy',
      icon: '/img/icons/coursemoduleicons/052-protest.svg',
      parts: [
        {
          id: 1,
          title: 'Policy, advocacy and communication',
          description: "Policy advocacy in the context of climate change adaptation involves efforts to influence public policy and decision-making processes to address the impacts of climate change and enhance the resilience of communities. This type of advocacy aims to ensure that policies are in place to help societies adapt to the changing climate, protect vulnerable populations, and promote sustainable development. Here's what it involves:",
          subtitle: 'What is policy advocacy for climate change?',
          template: 'explanation',
          subparts: [
            {
              id: 1,
              title: 'Raising awareness',
              description: [
                'Telling people, especially those in charge, about why we need to adapt to climate change and how it affects different communities.',
              ],
            },
            {
              id: 2,
              title: 'Building teams',
              description: [
                'Teaming up with other groups and people who care about climate change to make our voice stronger and push for change together.',
              ],
            },
            {
              id: 3,
              title: 'Research and evidence',
              description: [
                'Using facts, science, and real-life examples to show why climate adaptation policies are important and how they can help.',
              ],
            },
            {
              id: 4,
              title: 'Talking to policymakers',
              description: [
                'Speaking directly to government leaders and lawmakers to encourage them to create and follow policies that protect the planet and people.',
              ],
            },
            {
              id: 5,
              title: 'Public campaigns',
              description: [
                'Organising events, social media campaigns, or activities to get people involved and help create pressure for change.',
              ],
            },
            {
              id: 6,
              title: 'Monitoring and accountability',
              description: [
                'Keeping track of whether the policies work and if the leaders are keeping their promises to fight climate change.',
              ],
            },
          ],
        },
        {
          id: 2,
          title: 'Develop a plan',
          // description: 'Who are your addressing and what is their background, interests and level of expertise of your target audience e.g policy makers, stakeholders or community leaders.',
          template: 'checklist',
          subparts: [
            {
              id: 1,
              title: 'Identify your audience',
              description: [
                'Who are you addressing, and what are their backgrounds, interests and levels of expertise, e.g. policy-makers, stakeholders, or community leaders?',
              ],
            },
            {
              id: 2,
              title: 'Define the issue',
              description: [
                'Clearly articulate the problem or issues, including the relevant context, to help your audience understand its significance.',
              ],
            },
            {
              id: 3,
              title: 'Conduct thorough research',
              description: [
                'Gather evidence and data, including statistics, case studies and expert opinions. Ensure this is taken from credible sources.',
              ],
            },
            {
              id: 4,
              title: 'Develop key messages',
              description: [
                'Pinpoint the main takeaways that you want the target audience to remember. They should be clear, focused and supported by research.',
              ],
            },
            {
              id: 5,
              title: 'Outline the structure',
              subtitle: 'A policy brief includes a number of sections:',
              description: [
                'Title – Concise and informative.',
                'Executive summary: brief overview of the issue, key findings and recommendations.',
                'Background/Context: Detailed information about the issue, its significance, and any relevant historical context.',
                'Key Findings: Present the main evidence that supports your recommendations. Use bullet points for clarity.',
                'Recommendations: Outline specific actions policymakers or stakeholders can take.',
                'Conclusion: Summarise your main points and reinforce the importance of taking action.',
                'References: List the sources you used in your research.',
              ],
            },
            {
              id: 6,
              title: 'Write clearly and concisely',
              description: [
                'Use plain language: Avoid jargon and technical terms that might confuse your audience. Aim for brevity and clarity.',
                'Be persuasive: Make a compelling case for why your recommendations should be considered.',
              ],
            },
          ],
        },
        {
          id: 3,
          title: 'How to organise a campaign',
          template: 'checklist',
          subparts: [ 
            { 
              id: 1,
              title: 'Define the goals',
              description: [
                'Clarify Objectives: Identify what you want to achieve (e.g., increase awareness).',
                'Set SMART Goals: Ensure your goals are Specific, Measurable, Achievable, Relevant, and Time-bound.',
              ],
            },
            {
              id: 2,
              title: 'Identify your target audience',
              description: [
                'Research Demographics: Understand who your audience is based on age, gender, location, interests, and behaviour.',
                'Create Personas: Develop detailed profiles of your ideal supporters or customers to tailor your message.',
              ],
            },
            {
              id: 3,
              title: 'Develop a compelling message',
              description: [
                'Create key messages: Define the core message you want to communicate. Make it clear, concise, and impactful.',
                'Storytelling: Use narratives and testimonials to make your message relatable and engaging.',
              ],
            },
            {
              id: 4,
              title: 'Choose your campaign channels',
              description: [
                'Select platforms: Decide which channels (social media, events, traditional media) will best reach your audience.',
                'Multi-Channel Approach: may consider a mix of online and offline tactics for broader reach and engagement.',
              ],
            },
            {
              id: 5,
              title: 'Create a campaign plan',
              description: [
                'Timeline: Develop a schedule with key milestones and deadlines. Budget: Estimate costs and allocate resources for different activities. Roles and responsibilities: Assign specific tasks to team members to ensure accountability.',
              ],
            },
            {
              id: 6,
              title: 'Develop content and creative assets',
              description: [
                'Visuals and branding: Create eye-catching graphics, videos, and promotional materials consistent with your brand identity. Content strategy: Plan what content will be shared on each channel.',
              ],
            },
            {
              id: 7,
              title: 'Launch your campaign',
              description: [
                'Kick-off: Plan a launch event or announcement to generate initial buzz, engage with followers by responding to comments and messages, and facilitate discussions.',
              ],
            },
          ],
        },
      ],
    },
  ],
}

const moduleSessions = [moduleOne, moduleTwo, moduleThree, moduleFour]

export {
  modulesTopics,
  moduleSessions,
}